import { AuthClient } from "../data/auth-client";

async function RecoverPassword(email) {
  try {
    const authClient = new AuthClient();

    await authClient.forgotPassword(email);
   
    
  } catch (err) {
    console.error("Recover password error", err);
    throw err;  // Propagate the error to the caller
  }
}

export default RecoverPassword;
